import RedirectHelper from '../../../components/RedirectHelper';

const Login = (): JSX.Element => {
  RedirectHelper.redirectToUserManagement('/login');
  return <></>;
};

export default Login;
